import { createContext, useContext, useSyncExternalStore, type ReactNode } from 'react';

import { getAuthSession, type AuthSession, type AuthState } from './auth-session';

const AuthContext = createContext<AuthSession | undefined>(undefined);

/** Injeta a sessão (valor estável). Sem provider, `useAuth` usa a sessão criada no boot. */
export function AuthProvider({ session, children }: { session: AuthSession; children: ReactNode }) {
  return <AuthContext value={session}>{children}</AuthContext>;
}

export interface UseAuth extends AuthState {
  session: AuthSession;
  isAuthenticated: boolean;
}

/** Estado da sessão Cognito + a própria sessão para chamar as ações (`session.signIn`…). */
export function useAuth(): UseAuth {
  const session = useContext(AuthContext) ?? getAuthSession();
  const state = useSyncExternalStore(session.subscribe, session.getState, session.getState);
  return { ...state, session, isAuthenticated: state.status === 'signedIn' };
}
